function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:#777;}.cls-3{fill:#383838;}.cls-10,.cls-11,.cls-12,.cls-14,.cls-17,.cls-4,.cls-6{fill:none;}.cls-4{stroke:#e5e5e5;}.cls-10,.cls-11,.cls-14,.cls-17,.cls-4,.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-11,.cls-4{stroke-width:3.06px;}.cls-16,.cls-5{fill:#8ce08c;}.cls-5{fill-rule:evenodd;}.cls-6{stroke:#2f855a;stroke-width:3.65px;}.cls-7{fill:#ed8936;}.cls-8{fill:#2f855a;}.cls-9{fill:#c2c2c2;}.cls-10{stroke:#9ef5ee;stroke-width:5.14px;}.cls-11{stroke:#909090;}.cls-12{stroke:#000;stroke-miterlimit:10;}.cls-13{fill:#fefddb;}.cls-14{stroke:#8ce08c;stroke-width:6.1px;}.cls-15,.cls-19{fill:#9ef5ee;}.cls-17{stroke:#fff;stroke-width:16.23px;}.cls-18{fill:#fff;}.cls-19{opacity:0.75;}\n"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "vector"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M753.53,207.08c81.22,119.24,120.89,254.18,79.56,344.7S669.22,688.38,560.93,726s-202.52,67-281.88,38.85c-79.56-28.11-144.24-113.25-157.26-201.28-13.23-88.24,25.42-179.38,84.93-293.45C266,155.83,346.42,18.82,447.89,1.87,549.36-15.28,672.11,88.05,753.53,207.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M440.83,591c9,8,99,224,106,238,9-7,51-17,67-3-14,11-82,62-82,62l-93-133Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M502,725c-26.69-62.09-56.2-129.55-61.16-134l-2,164,28.82,41.22C485.49,770.68,496.16,746.82,502,725Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M468.33,571.49c0-129,104.57-233.57,233.57-233.57S935.47,442.49,935.47,571.49,830.9,805.06,701.9,805.06,468.33,700.49,468.33,571.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M113.24,216.5a48.42,48.42,0,1,0-35.47,58.57A48.42,48.42,0,0,0,113.24,216.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M95.9,210.44c-1-4.05-3.34-7-5.23-6.5s-2.61,4.13-1.61,8.19,3.34,7,5.22,6.5S96.9,214.5,95.9,210.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M87.83,304c97.71-29,141,167,144,231-6,23-120,60-156,46C51.83,527-3.17,331,87.83,304Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 13.83,
  y: 89.01,
  width: 23,
  height: 87,
  rx: 11.5,
  transform: "translate(-54.81 23.98) rotate(-25.62)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M172.46,580.74C219.83,561,389.83,540,433.83,570c33.23,22.66,13,296,13,296,13,0,61,25,61,45h-115l1-54-43-173L208.24,716"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 142.6,
  y1: 312.39,
  x2: 37.62,
  y2: 416.48
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 178.19,
  y1: 351.63,
  x2: 46.28,
  y2: 482.82
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 204.01,
  y1: 398.31,
  x2: 60.62,
  y2: 540.48
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 217.89,
  y1: 451.49,
  x2: 85.7,
  y2: 583.4
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 228.35,
  y1: 502.57,
  x2: 155.66,
  y2: 574.64
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-11",
  points: "12.04 395.89 81.62 736.57 337.32 691.6"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-11",
  x1: 119.19,
  y1: 729.97,
  x2: 69.84,
  y2: 861.33
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-12",
  x1: 258.87,
  y1: 705.4,
  x2: 317.45,
  y2: 861.33
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 309.99,
  y: 23.33,
  width: 616.29,
  height: 372.56
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 153.47,
  y1: 85.8,
  x2: 926.28,
  y2: 85.8
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-15",
  points: "788.04 11.86 761.16 58.42 814.92 58.42 788.04 11.86"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 855.89,
  cy: 33.33,
  r: 25.78
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 780.56,
  cy: 243.12,
  r: 91.89
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-16",
  x: 905.38,
  y: 9.67,
  width: 48.74,
  height: 48.74
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 371.54,
  y1: 153.19,
  x2: 507.98,
  y2: 153.19
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 371.54,
  y1: 184.01,
  x2: 507.98,
  y2: 184.01
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 371.54,
  y1: 214.84,
  x2: 507.98,
  y2: 214.84
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 371.54,
  y1: 245.66,
  x2: 507.98,
  y2: 245.66
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 371.54,
  y1: 276.49,
  x2: 507.98,
  y2: 276.49
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-10",
  x1: 371.54,
  y1: 307.31,
  x2: 507.98,
  y2: 307.31
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M170.88,386.56c-3.53-11.75-16.26-35.06-32.63-49"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-8",
  cx: 200.33,
  cy: 645.51,
  r: 70.5
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-18",
  x: 21.98,
  y: 104.29,
  width: 4.11,
  height: 26.86,
  rx: 2.06,
  transform: "translate(-48.54 21.97) rotate(-25.62)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M254,335.75a34.32,34.32,0,1,1,34.32,34.31A34.31,34.31,0,0,1,254,335.75Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-19",
  points: "744.32 259.6 590.68 139.4 552.8 296.64 744.32 259.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M236.59,579.1a34.32,34.32,0,1,1,34.32,34.31A34.32,34.32,0,0,1,236.59,579.1Z"
})));

var SvgWatermelonPackIllustration02 = function SvgWatermelonPackIllustration02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 954.12 911.01",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelonPackIllustration02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-02.2bf245fd.svg";
export { ForwardRef as ReactComponent };